export const notPerformedReasons = {
  contraindicated: [
    'CONTRAINDICATED_UNSTABLE_ANGINA',
    'CONTRAINDICATED_MYOCARDIAL_INFARCT',
    'CONTRAINDICATED_RESTING_PULSE_TOO_HIGH',
    'CONTRAINDICATED_BLOOD_PRESSURE_TOO_HIGH',
  ],
  other: [
    'FORGOT',
    'NOTIME',
    'DONOTWANT',
    'OTHER',
  ],
};

export const notPerformedReasonGroups = [
  'contraindicated',
  'other',
];
